import React from "react";

const Profile = (props) => {
  return (
    <section id={props.isNightMode ? "dark" : "light"} className="profile">
      <h3 id={props.isNightMode ? "dark" : "light"}>Profile</h3>

      <div
        id={props.isNightMode ? "dark" : "light"}
        className="profile-container">
        <div id={props.isNightMode ? "dark" : "light"} className="information">
          <h4 id={props.isNightMode ? "dark" : "light"}>Basic Information</h4>

          <div
            id={props.isNightMode ? "dark" : "light"}
            className="profile-basic-information">
            <div className="profile-informations">
              <li id={props.isNightMode ? "dark" : "light"}>Date of birth</li>
              <li id={props.isNightMode ? "dark" : "light"}>City</li>
              <li id={props.isNightMode ? "dark" : "light"}>
                Education <br />
              </li>
              <li></li>
              <li id={props.isNightMode ? "dark" : "light"}>Role</li>
            </div>
            <div
              id={props.isNightMode ? "dark" : "light"}
              className="profile-answers">
              <li id={props.isNightMode ? "dark" : "light"}>10.01.1988</li>
              <li id={props.isNightMode ? "dark" : "light"}>Istanbul</li>
              <li id={props.isNightMode ? "dark" : "light"}>
                Selcuk Unv. Engineering Faculty, 2014
              </li>
              <li id={props.isNightMode ? "dark" : "light"}>Frontend, UI</li>
            </div>
          </div>
        </div>
        <div className="profile-about-me">
          <h5 id={props.isNightMode ? "dark" : "light"}>About me</h5>
          <p id={props.isNightMode ? "dark" : "light"}>
            With my strong problem-solving skills and experience in various
            programming languages, I am capable of tackling complex projects
            with ease. My passion for technology drives me to stay updated on
            industry trends and continuously improve my skills. I am also a team
            player and enjoy collaborating with others to bring creative
            solutions to the table. Whether working independently or as part of
            a team, I am committed to delivering high-quality results in a
            timely manner.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Profile;
